import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import validateError from '../../ValidateError';
import { useNavigate } from 'react-router-dom';

const server_backend = config.API_URL;

function AddLiveJobComment({ JobID, onClose, getJobs, isBegin, Qty, isScanPoint }) {
    const [loading, setLoading] = useState(false);
    const RouteLocation = useNavigate();
    const [formData, setFormData] = useState({
        title: isBegin === false ? "PRINT" : "",
        comment: '',
        qty: 0,
        reference: isBegin === true ? 1 : 0,
        id: JobID,
    });

    const handleChange = (e) => {
        const { name, qty, value } = e.target;
        //console.log(name, qty, value);
        setFormData({
            ...formData,
            [name]: value,
            [qty]: value,
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        if (isBegin === true) {
            if (formData.qty <= 0 || formData.title == '') {

                Swal.fire({
                    icon: 'error',
                    title: 'Please fill all fields',
                    showConfirmButton: false,
                    timer: 2000
                });
                setLoading(false);
                return;

            }
        }
        try {
            const response = await axios.post(`${server_backend}/Jobs/manual/tracking/insert`, formData, headers);
            //console.log(response.data);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Saved Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
                onClose();
                //handleSelectQuantity()
                if (isBegin && isScanPoint) {
                    RouteLocation("/jobs-reprint-folder");
                }
                getJobs();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'An error occurred, please try again.',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            console.log(error);
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade bs-example-modal-xl show azoomOutDown" tabIndex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-modal="true" style={{ display: "block", backgroundColor: "#0101019e" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myExtraLargeModalLabel">Reason for {isBegin === false ? "Print" : "Reprint"}</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                <div className="col-md-12">
                                    {isBegin === true ? (
                                        <>
                                            <div className="mb-3">
                                                <label htmlFor="title" className="form-label">Situation</label>
                                                <select
                                                    className="form-select"
                                                    id="title"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select a situation...</option>
                                                    <option value="Broken wax">Broken wax</option>
                                                    <option value="Casting failure">Casting failure</option>
                                                    <option value="Wrong colour">Wrong colour</option>
                                                    <option value="Wrong amount">Wrong amount</option>
                                                    <option value="Cancellation">Cancellation</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="title" className="form-label">Qty</label>
                                                <select
                                                    className="form-select"
                                                    id="qty"
                                                    name="qty"
                                                    value={formData.qty}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value={0}>Select Qty...</option>
                                                    {[...Array(Qty)].map((_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}


                                                </select>
                                            </div>
                                        </>
                                    ) : (


                                        <div className="mb-3">
                                            <label htmlFor="title" className="form-label">Situation</label>
                                            <select
                                                className="form-select"
                                                id="title"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                required
                                            >

                                                <option value="PRINT">PRINTED</option>
                                                <option value="PRINT FOLDER">PRINT FOLDER</option>

                                            </select>
                                        </div>



                                    )}

                                </div>
                                <div className="col-md-12">

                                    <div className="mb-3">

                                        <textarea
                                            className="form-control"
                                            placeholder="Enter your comment here"
                                            id="comment"
                                            style={{ minHeight: "178px" }}
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}

                                        ></textarea>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="text-end">
                                        <button type="submit" className={`btn btn-${isBegin === false ? "success" : "primary"}`} >
                                            {isBegin === false ? "Start Printing" : "Submit"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddLiveJobComment;
